import * as Yup from "yup";
import JsonFile from "../../Utils/JsonFile";

let json = JsonFile(window.localStorage.getItem("language"));
const content = json?.Validation;

export const LoginSchema = Yup.object().shape({
    email_or_phone: Yup.string().required(content.emailOrphone)
        .matches(/(^[a-zA-Z0-9._-]+@[a-zA-Z.]+\.[a-zA-Z]{2,}$)|(^[0-9]{11}$)/, "فرمت شماره تلفن یا ایمیل درست نمی‌باشد"),

});

export const LoginPasswordSchema = Yup.object().shape({
    password: Yup.string().required(content.password)
        .min(8, content.passwordMin)
});

export const ForgetPasswordSchema = Yup.object().shape({
    new_password: Yup.string().required(content.password)
        .min(8, content.passwordMin),
    code: Yup.string().required(content.pin)
        .min(5, content.pinMax)
        .max(5, content.pinMax),
    confirm_password: Yup.string()
        .oneOf([Yup.ref('new_password'), null], content.passwordConfirm)
        .required(content.passwordConfirmRequired)
});

export const OneTimePasswordSchema = Yup.object().shape({
    code: Yup.string().required(content.oneTimePasswor)
        .min(5, content.oneTimePassworMin)
        .max(5, content.oneTimePassworMin)

});

export const RegisterSchema = Yup.object().shape({
    name: Yup.string().required(content.name)
        .min(3, content.nameMin),
    family: Yup.string().required(content.family).min(3, content.familyMin),
    phone_number: Yup.string().required(content.phone)
        .min(11, content.phoneMin)
        .max(11, content.phoneMin)
    ,
    email: Yup.string().required(content.emailRequired)
        .matches(/^[a-zA-Z0-9._-]+@[a-zA-Z.]+\.[a-zA-Z]{2,}$/, content.email),
    password: Yup.string().required(content.password)
        .min(8, content.passwordMin),
    confirm_password: Yup.string()
        .oneOf([Yup.ref('password'), null], content.passwordConfirm)
        .required(content.passwordConfirmRequired)
});


export const CreateTicketSchema = Yup.object().shape({
    subject: Yup.string().required(content.Required),
    // service_code: Yup.string().required(content.Required),
    // user_role: Yup.string().required(content.Required),
    context: Yup.string().required(content.Required),
    // priority: Yup.string().required(content.Required)
});


export const AnswerTicketSchema = Yup.object().shape({
    context: Yup.string().required(content.Required)
});
export const addressSchema = Yup.object().shape({
    address: Yup.string().required(content.Required)
});

export const changePasswordSchema = Yup.object().shape({
    old_password: Yup.string().required(content.Required),
    new_password: Yup.string().required(content.password)
        .min(8, content.passwordMin),
    confirm_password: Yup.string()
        .oneOf([Yup.ref('new_password'), null], content.passwordConfirm)
        .required(content.passwordConfirmRequired)
});

// export const editProfileSchema = Yup.object().shape({
//     name: Yup.string().required(content.name)
//         .min(3, content.nameMin),
//     family: Yup.string().required(content.family).min(3, content.familyMin),
//     phone_number: Yup.string().required(content.phone)
//         .min(11, content.phoneMin)
//         .max(11, content.phoneMin)
//     ,
//     email: Yup.string().email(content.email).required(content.emailRequired)
// });